// GalleryMarkerManager.js
import { OnePointMarker } from './OnePointMarker.js';
import {TwoPointCircleMarker} from "./TwoPointCircleMarker.js";
import {ThreePointViewMarker} from "./ThreePointViewMarker.js";
import {FivePointPlaneMarker} from "./FivePointPlaneMarker.js";
// Importiere bei Bedarf weitere Markerklassen

export class GalleryMarkerManager {
    markerFactory;

    offsetOptions = {
        // offsetX: 0.0001,
        // offsetY: 0.0001
    }

    constructor(mapAdapter, markerFactory) {
        this.mapAdapter = mapAdapter;
        this.markerFactory = markerFactory;
        this.markers = [];
    }

    clearAll() {
        for (const m of this.markers) m.clear();
        this.markers = [];
    }

    addMarkers(map, { locations = [], viewpoints = [] } ) {
        // ToDo: legacy check wegen viewpoints, aber erst abklären
        let fusedLocations = [...locations, ...viewpoints];
        this.clearAll();
        for (const loc of fusedLocations) {
            const points = loc.markers.map(m => ({
                lat: parseFloat(m.lat),
                lng: parseFloat(m.lng)
            }));

            //const opts = optionsPerLocation(loc) || {};

            let options = { color: '#03f5f1'};
            options = {...options, ...this.offsetOptions };

            let marker;
            // ToDo: in factory auslagern
            switch (points.length) {
                case 1:
                    marker = new OnePointMarker(this.mapAdapter, this.markerFactory, points, options);
                    break;
                case 2:
                    marker = new TwoPointCircleMarker(this.mapAdapter, this.markerFactory, points, options);
                    break;
                case 3:
                    marker = new ThreePointViewMarker(this.mapAdapter, this.markerFactory, points, options);
                    break;
                case 5:
                    marker = new FivePointPlaneMarker(this.mapAdapter, this.markerFactory, points, options);
                    break;
                default:
                    console.warn('Unknown marker shape for location', loc);
            }

            if (marker) {
                marker.draw(map);
                this.markers.push(marker);
            }
        }
    }

    getMarkers(index = null) {
        if(index != null && index > this.markers.length - 1) {
            console.error("[GalleryMarkerManager] getMarkers: index not found: ", index);
            return;
        }

        if (index === null) {
            return this.markers;
        } else {
            return [this.markers[index]];
        }
    }
}

